import { render, staticRenderFns } from "./ISFDetailParties.vue?vue&type=template&id=9ee9f654&"
import script from "./ISFDetailParties.vue?vue&type=script&lang=js&"
export * from "./ISFDetailParties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports